import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EToastType, HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { FacilityObject, RFIDMember, RFIDMemberResponse, UpdateRFIDMember } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { RfidMemberService } from 'src/app/post-login/services/rfid-member.service';
import { Event } from '@angular/router';
import { Subscription } from 'rxjs';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { ConfirmationModalPopupComponent } from 'src/app/core/confirmation-modal-popup/confirmation-modal-popup.component';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';



interface IOutput {
  rowsPerPage: number;
  currentPage: number;
}

@Component({
  selector: 'app-rfid-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit, OnDestroy {
  private _members: RFIDMember[]; // original data
  private _membersFiltered: RFIDMember[];
  public membersLength: number = 0;
  private _isMobile: boolean;
  public showDeleteModal: boolean;
  public lastDeletedUser: string;
  public form: FormGroup;
  public submitted: boolean = false;
  public errorMsgEmail: string;
  public errorMsgEmailInvalid: string;
  public errorMsgEmailDuplicate: string;
  public errorMsgFirstName: string;
  public errorMsgLastName: string;
  public errorMsgRFID: string;
  public errorMsgRFIDInvalid: string;
  public errorMsgRFIDDuplicate: string;
  public errorMsgGender: string;
  public sliceFrom: number = 0;
  public sliceTo: number = 0;
  public errors: number = 0;
  public keyword: string = '';
  public deleteModalProps = {
    title: 'Delete RFID User?',
    message: 'DELETE.MODAL.MESSAGE',
    isWarningPopup: true,
    ctaButtonLabel: 'DELETE',
    negativeButtonLabel: 'CANCEL',
    isCloseIconCallsCta: false,
    isSecondaryTextButton: true,
  };
  popupMessageData = {
    title: 'REMOVE.MEMBER',
    message: 'REMOVE.MEMBER.CONFIRM',
    isWarningPopup: true,
    ctaButtonLabel: 'REMOVE',
    negativeButtonLabel: 'CANCEL',
    isCloseIconCallsCta: false,
    isSecondaryTextButton: true,
    additionalMessage: ['']
  };
  // subscriptions
  private _facilityOnChange: Subscription;
  currentFacility: FacilityObject;
  hasEditPermission: boolean= true;
  rootScopeData: RootScopeDeclare;
  showRFIDConfirmationModal = false;
  isRefresh = false;
  delinkRemoveResponse: any = {};

  checkedAll = false;
  showActionBtns = false;
  showPopupMessage = false;

  @Input() set members(val: RFIDMember[]) {
    this._members = val;
    this._membersFiltered = val;
    this.membersLength = val.length;

    // error data get
    this.errors = 0;
    val.forEach((i) => {
      if (i.rfId && i.rfId.match(/[0-9a-fA-F]+/)?.length) {
      } else {
        if (i.rfId) this.errors++;
      }
    });
  }

  @Input() needToUpdateOnParent: boolean;
  @Output() onUpdate: EventEmitter<RFIDMember[]> = new EventEmitter();
  @Output() callOnChanges: EventEmitter<boolean> = new EventEmitter();
  @Output() onRefresh: EventEmitter<boolean> = new EventEmitter();

  get members(): RFIDMember[] {
    return this._membersFiltered;
    // return this._members;
  }

  @Input() set isMobile(val: boolean) {
    this._isMobile = val;
  }

  get isMobile(): boolean {
    return this._isMobile;
  }

  @ViewChild(ConfirmationModalPopupComponent) modalComponent: ConfirmationModalPopupComponent;

  constructor(
    private fb: FormBuilder,
    private _utils: CommonUtil,
    private _rfidMemberService: RfidMemberService,
    private _toast: HaloToastService,
    private _facilityService: FacilityService,
    private _rootScopeService: RootScopeService,
    private _loader: HaloLoaderService,
    private _amplitudeService: AmplitudeAnalyticsService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      userId: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email, Validators.pattern(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+[.][A-Za-z]{2,50}$/)]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      rfId: ['', [Validators.pattern('[0-9 a-f A-F]+')]], // ^[a-z0-9_-]{8,15}$ --- /[0-9 a-f A-F]+/
      gender: ['', [Validators.required]],
    });

    //.
    this.onValueChanges();
    this.errorMessage();
    this.deleteModalProps.title = this._utils.replaceValueAsHTMLOnTranslatedText('DELETE.NO', [
      this._utils.translateText('RFID.USER'),
    ]);
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
      if(this.currentFacility.summary.userRights.facility === 'F')
        this.hasEditPermission = true;
      else
        this.hasEditPermission = false;
    });
    this.currentFacility = this._facilityService.selectedFacility();

    this.getRootScopeData();
    if(this.currentFacility.summary.userRights.facility === 'F')
      this.hasEditPermission = true;
    else
      this.hasEditPermission = false;
  }
  
  ngOnDestroy(): void {
    this._facilityOnChange?.unsubscribe();
  }

  getRootScopeData(): void {
    this._rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }
  onValueChanges(): void {
    this.form.valueChanges.subscribe((val) => {
      if (!this.needToUpdateOnParent) this.callOnChanges.emit(true);
    });
  }

  get field() {
    return this.form.controls;
  }

  deleteMember(uId: RFIDMember['userId']) {
    if (this.needToUpdateOnParent) {
      this.members = this.members.filter((member) => member.userId !== uId);
    } else {
      this.showDeleteModal = true;
      this.lastDeletedUser = uId;
    }
  }

  deleteMemberConfirmed() {
    this._amplitudeService.logEvent({elementName: 'Remove', action: 'Submit'});
    this._rfidMemberService.deleteRFIDMember(this.lastDeletedUser).subscribe(
      (res) => {
        this.members = this.members.filter((member) => member.userId !== this.lastDeletedUser);
        this.closeDeleteModal();
        //this.updateOnList(this.form.value);
      },
      (err) => {
        this.closeDeleteModal();
        this.initCustomPopupMessage();
        this.rootScopeData.showCustomModal = true;
      }
    );
  }

  closeDeleteModal() {
    this.showDeleteModal = false;
  }

  openForm(member: RFIDMember) {
    this._members.map((m) => {
      if (m != member) m.isEditFormOpen = false;
      return true;
    });

    member.isEditFormOpen = !member.isEditFormOpen;
    this.submitted = false;

    if (member.isEditFormOpen) {
      this.form.patchValue({
        userId: member.userId,
        email: member.email,
        firstName: member.firstName,
        lastName: member.lastName,
        rfId: member.rfId,
        gender: member.gender,
      });

      if (member.isDuplicateRfid == 'true') {
        this.submitted = true;
        this.form.controls['rfId'].setErrors({ duplicate: true });
      }

      if (member.isRfidError == 'true') {
        this.submitted = true;
        this.form.controls['rfId'].setErrors({ invalid: true });
      }

      if (member.isEmailError == 'true') {
        this.submitted = true;
        this.form.controls['email'].setErrors({ invalid: true });
      }

      if (member.isGenderError == 'true') {
        this.submitted = true;
        this.form.controls['gender'].setErrors({ required: true });
      }

      // if (member.isEmailError) {
      //   this.form.controls['email'].setErrors({ invalid: true });
      //   this.form.controls['email'].setErrors({ duplicate: true });
      //   this.form.controls['rfId'].setErrors({ invalid: true });
      //   this.form.controls['rfId'].setErrors({ duplicate: true });
      // }

      if (!this.needToUpdateOnParent) this.callOnChanges.emit(false);      
    }
    if (this.needToUpdateOnParent) this.onUpdate.emit(this._members);
  }

  initForm() {}

  onSubmit() {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    if (!this.needToUpdateOnParent) {
      this.callOnChanges.emit(false);
      this._amplitudeService.logEvent({elementName: 'Update', action: 'Submit'});
      this._rfidMemberService.updateRFIDMember(this.form.value).subscribe(
        (res) => {
          // TODO: Need to add correct toast message
          this._toast.creatToast(this._utils.translateText('SAVED'), EToastType.SUCCESS);
          this.updateOnList(this.form.value);
        },
        ({ error: err }) => {
          if (err?.includes('1105')) {
            this.form.controls['email'].setErrors({ invalid: true });
          }
          if (err?.includes('1106')) {
            this.form.controls['email'].setErrors({ duplicate: true });
          }
          if (err?.includes('1104')) {
            this.form.controls['rfId'].setErrors({ invalid: true });
          }
          if (err?.includes('1107')) {
            this.form.controls['rfId'].setErrors({ duplicate: true });
          }
          if(!err) {
            this.initCustomPopupMessage();
            this.rootScopeData.showCustomModal = true;
          }
        }
      );
    } else {
      this.updateOnList(this.form.value);
    }
  }

  updateOnList(data: UpdateRFIDMember) {
    this._members.map((m) => {
      if (m.isEditFormOpen) {
        m.email = data.email;
        m.firstName = data.firstName;
        m.gender = data.gender;
        m.lastName = data.lastName;
        m.userId = data.userId;
        m.rfId = data.rfId?.trim() == '' ? undefined : data.rfId?.trim();
        m.isEditFormOpen = false;

        // for remove validations
        m.isDuplicateRfid = 'false';
        m.isRfidError = 'false';
        m.isEmailError = 'false';
        m.isGenderError = 'false';
      }
    });

    if (this.needToUpdateOnParent) {
      this.onUpdate.emit(this._members);
    }
  }

  errorMessage() {
    this.errorMsgEmail = this._utils.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER.YOUR', [
      this._utils.translateText('EMAIL').toLowerCase(),
    ]);
    this.errorMsgFirstName = this._utils.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER.YOUR', [
      this._utils.translateText('LABEL.FIRSTNAME').toLowerCase(),
    ]);
    this.errorMsgLastName = this._utils.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER.YOUR', [
      this._utils.translateText('LABEL.LASTNAME').toLowerCase(),
    ]);
    this.errorMsgRFID = this._utils.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER.YOUR', [
      this._utils.translateText('RFID'),
    ]);
    this.errorMsgGender = this._utils.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER.YOUR', [
      this._utils.translateText('GENDER'),
    ]);

    this.errorMsgEmailDuplicate = this._utils.translateText('DUPLICATE.EMAIL.ADDRESS');
    this.errorMsgEmailInvalid = this._utils.translateText('INVALID.EMAIL.ADDRESS');
    this.errorMsgRFIDDuplicate = this._utils.translateText('DUPLICATE.RFID');
    this.errorMsgRFIDInvalid = this._utils.translateText('INVALID.RFID');
  }

  paginationChanged(val: IOutput) {
    this.sliceFrom = (val.currentPage - 1) * val.rowsPerPage;
    this.sliceTo = this.sliceFrom + val.rowsPerPage;
  }

  searching() {
    let _key = this.keyword.toLocaleLowerCase();
    this._membersFiltered = this._members.filter((item) => {
      return (
        (item.email ? item.email.toLocaleLowerCase().startsWith(_key) : false) ||
        (item.firstName ? item.firstName.toLocaleLowerCase().startsWith(_key) : false) ||
        (item.lastName ? item.lastName.toLocaleLowerCase().startsWith(_key) : false) ||
        (item.rfId ? item.rfId.toLocaleLowerCase().startsWith(_key) : false)
      );
    });
    this.membersLength = this._membersFiltered.length;
  }

  edit() {}

  onSelectAll() {
    this.checkedAll = !this.checkedAll;
    this.members.forEach(m => m.isSelected = this.checkedAll);
    this.showActionBtns = this.checkedAll;
  }

  onSelect(member: RFIDMember) {
    member.isSelected = !member.isSelected;
    if(member.isSelected) {
      this.checkedAll = this.members.every(m => m.isSelected);
      this.showActionBtns = true;
    } else {
      this.checkedAll = false;
      this.showActionBtns = this.members.some(m => m.isSelected);
    }    
  }

  removeMembers(member?: RFIDMember) {
    this.popupMessageData.title = 'REMOVE.MEMBER';
    this.popupMessageData.message = 'REMOVE.MEMBER.CONFIRM';
    this.popupMessageData.ctaButtonLabel = 'REMOVE';
    this.popupMessageData.additionalMessage = member ? [`• ${member.email}`] : this.members.filter(m => m.isSelected).map(m => `• ${m.email}`);
    this.showPopupMessage = true;
    // allow the current process to end before processing the showing of modal
    setTimeout(() => {            
      this.modalComponent.show(true).then(async res => {
        if(res == 1) {// confirmed
          // call api
          try {
            this._loader.startProcess();
            this._amplitudeService.logEvent({elementName: 'Remove', action: 'Submit'});
            let selectedMembers = member ? [{email: member.email, userId: member.userId, rfId: member.rfId}] :
              this.members.filter(m => m.isSelected).map(m => {return {email: m.email, userId: m.userId, rfId: m.rfId}});
            let response = await this._rfidMemberService.removeRFIDMembers(this.currentFacility.facilityId, selectedMembers) as any;
            let errorList = [];
            if(response.exceptionVOList) {              
              if(Array.isArray(response.exceptionVOList)) {
                errorList = response.exceptionVOList;
              } else {
                errorList = [response.exceptionVOList];
              }
            }
            this.delinkRemoveResponse.isDelink = false;
            this.delinkRemoveResponse.numberOfUsers = response.numberOfUsers;
            this.delinkRemoveResponse.failedUserInfo = errorList.map((l: any) => {
              return { 
                email: l.email, 
                errorStr: this._utils.translateText('INVALID.MEMBER') 
              };
            });
            this.isRefresh = parseInt(response.failedUsers) != selectedMembers.length;
            this.showRFIDConfirmationModal = true;
          } catch (error) {
            console.error('API error.');
            this.initCustomPopupMessage();
            this.rootScopeData.showCustomModal = true;
          }
          this._loader.endProcess();
        }
        this.showPopupMessage = false;
      });
    });
  }

  delinkRfids(member?: RFIDMember) {
    this.popupMessageData.title = 'DE-LINK.RFID';
    this.popupMessageData.message = 'DE-LINK.RDIF.CONFIRM';
    this.popupMessageData.ctaButtonLabel = 'DELINK.USER';
    this.popupMessageData.additionalMessage = member ? [`• ${member.email}`] : this.members.filter(m => m.isSelected).map(m => `• ${m.email}`);
    this.showPopupMessage = true;
    // allow the current process to end before processing the showing of modal
    setTimeout(() => {            
      this.modalComponent.show(true).then(async res => {
        if(res == 1) {// confirmed
          // call api
          try {
            this._loader.startProcess();
            this._amplitudeService.logEvent({elementName: 'Delink RFID', action: 'Submit'});
            let selectedMembers = member ? [{email: member.email, userId: member.userId, rfId: member.rfId}] :
              this.members.filter(m => m.isSelected).map(m => {return {email: m.email, userId: m.userId, rfId: m.rfId}});
            let response = await this._rfidMemberService.delinkRFIDs(this.currentFacility.facilityId, selectedMembers) as any;
            let errorList = [];
            if(response.exceptionVOList) {              
              if(Array.isArray(response.exceptionVOList)) {
                errorList = response.exceptionVOList;
              } else {
                errorList = [response.exceptionVOList];
              }
            }
            this.delinkRemoveResponse.isDelink = true;
            this.delinkRemoveResponse.numberOfUsers = response.numberOfUsers;
            this.delinkRemoveResponse.failedUserInfo = errorList.map((l: any) => {
              return { 
                email: l.email, 
                errorStr: this._utils.translateText(l.errorStr === 'empty-rfId' ? 'EMPTY.RFID' : 
                  l.errorStr === 'member-doesnt-exist' ? 'MEMBER.NOT.EXIST' : 
                  l.errorStr === 'invalid-member' ? 'INVALID.MEMBER' : 'INVALID.MEMBER') 
              };
            });
            this.isRefresh = parseInt(response.failedUsers) != selectedMembers.length;
            this.showRFIDConfirmationModal = true;
          } catch (error) {
            console.error('API error.');
            this.initCustomPopupMessage();
            this.rootScopeData.showCustomModal = true;
          }
          this._loader.endProcess();
        }
        this.showPopupMessage = false;
      });
    });
  }

  rfidConfirmClose() {
    this.showRFIDConfirmationModal = false;
    if(this.isRefresh) {
      this.checkedAll = false;
      this.onRefresh.emit();
    }
  }
  
  initCustomPopupMessage() {
    this.rootScopeData.customPopupData = {
      title: 'OOPS',
      message: 'CUSTOM.LOADER.ERROR.MSG.APIFAILED',
      isWarningPopup: true,
      ctaButtonLabel: 'OK',
      isSecondaryTextButton: false,
      hideSecondaryButton: true
    };
  }
}
